import React, {useContext, useState} from "react";
import { ProfileContext } from "../ProfileContext";


const SendMail = () =>{

    const [btnloading, setBtnLoading] = useState(false);

    return(
    <div className="card">
        <div className="card border mb-0">
            <div className="card-body pb-0">
                <div className="row align-items-center">
                    <div className="mb-3">
                        <label className="form-label"> To</label>
                        <input type="text" className="form-control" name="to" id="to" defaultValue='abc@gmail.com' readOnly />
                    </div>
                    <div className="mb-3">
                        <label className="form-label"> Subject</label>
                        <input type="text" className="form-control" name="subject" id="subject" />
                    </div>
                    <div className="mb-3">
                        <label className="form-label"> Mail Content</label>
                        <textarea className="form-control" name="mailtext" id="mailtext" rows={5} cols={50}></textarea>
                    </div>
                    <div className="mb-3">
                        <div className="text-end">
                            <button type="button" className="btn btn-primary">
                                {btnloading ?
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                :
                                    <p>Send Mail</p>
                                }
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default SendMail;